import { useState } from 'react'

export const usePersistedState = <T>(
  key: string,
  defaultValue: T,
): [T, React.Dispatch<React.SetStateAction<T>>] => {
  const [state, setInternalState] = useState<T>(() => {
    try {
      const storedValue = localStorage.getItem(key)
      return storedValue ? JSON.parse(storedValue) : defaultValue
    } catch {
      return defaultValue
    }
  })

  const setState = (value: React.SetStateAction<T>) => {
    setInternalState((oldValue) => {
      if (typeof value === 'function') {
        value = (value as (oldValue: T) => T)(oldValue)
      }

      try {
        localStorage.setItem(key, JSON.stringify(value))
      } catch {
        console.error('Error saving to localStorage')
      }

      return value
    })
  }

  return [state, setState]
}
